<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div id="master_schedule_fluid" class="container-fluid">
        <!-- #region TITLE MASTER SCHEDULE -->
        <div class="mydiv">
          
        </div>
        <!--#endregion -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    initData() {},
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.subs.forEach((unsub) => unsub());
  },
};
</script>
<style scoped>

</style>
